module.exports = __webpack_public_path__ + "img/guinea_bissau.3b0958d.webp";